import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Modifier, ContentState, EditorState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';

import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import './styles.css';

const TextEditor = props => {
  const {
    name,
    enableHyperlinks,
    editorState,
    isValid,
    touchFunc,
    controlFunc,
  } = props;
  const inputClassNames = isValid
    ? 'text-editor'
    : 'text-editor text-editor--invalid';

  const onEditorStateChange = editorState => {
    controlFunc(name, editorState);
  };

  const onEditorBlur = () => {
    touchFunc(name, true, true);
  };

  const options = useMemo(
    () =>
      ['inline', 'blockType']
        .concat(enableHyperlinks ? ['link'] : [])
        .concat(['list', 'textAlign', 'remove', 'history']),
    [enableHyperlinks]
  );

  const handlePastedText = (text, html, editorState) => {
    const pastedBlocks = ContentState.createFromText(text).blockMap;
    const newState = Modifier.replaceWithFragment(
      editorState.getCurrentContent(),
      editorState.getSelection(),
      pastedBlocks
    );
    const newEditorState = EditorState.push(
      editorState,
      newState,
      'insert-fragment'
    );
    onEditorStateChange(newEditorState);
    return true;
  };

  return (
    <Editor
      handlePastedText={handlePastedText}
      editorState={editorState}
      toolbarClassName="text-editor__toolbar"
      wrapperClassName="text-editor__wrapper"
      editorClassName={inputClassNames}
      stripPastedStyles={true}
      onEditorStateChange={onEditorStateChange}
      onBlur={onEditorBlur}
      toolbar={{
        options,
        inline: {
          inDropdown: false,
          className: undefined,
          component: undefined,
          dropdownClassName: undefined,
          options: ['bold', 'italic', 'underline', 'strikethrough'],
          bold: { className: undefined },
          italic: { className: undefined },
          underline: { className: undefined },
          strikethrough: { className: undefined },
          monospace: { className: undefined },
        },
        blockType: {
          inDropdown: true,
          options: ['Normal', 'H3', 'H4', 'H5'],
          className: undefined,
          component: undefined,
          dropdownClassName: undefined,
        },
        list: {
          inDropdown: false,
          className: undefined,
          component: undefined,
          dropdownClassName: undefined,
          options: ['unordered', 'ordered'],
          unordered: { className: undefined },
          ordered: { className: undefined },
        },
        textAlign: {
          inDropdown: false,
          className: undefined,
          component: undefined,
          dropdownClassName: undefined,
          options: ['left', 'center', 'right', 'justify'],
          left: { className: undefined },
          center: { className: undefined },
          right: { className: undefined },
          justify: { className: undefined },
        },
        remove: {
          className: undefined,
          component: undefined,
        },
        history: {
          inDropdown: false,
          className: undefined,
          component: undefined,
          dropdownClassName: undefined,
          options: ['undo', 'redo'],
          undo: { className: undefined },
          redo: { className: undefined },
        },
      }}
    />
  );
};

TextEditor.propTypes = {
  editorState: PropTypes.object.isRequired,
  controlFunc: PropTypes.func.isRequired,
  enableHyperlinks: PropTypes.bool,
  isValid: PropTypes.bool.isRequired,
  touchFunc: PropTypes.func,
};

export default TextEditor;
